<template>
  <div id="footer" class="h-32">
    <!-- Back to top button -->
    <a id="button" href="#nav" :class="'bg-blue-500 rounded-full ' + (windowTop > 300 ? 'show' : '')"></a>
    <div class="text-center pt-6 md:pt-12 text-xl sm:text-2xl text-white">
      © Copyright 2022 M Hendry Prasetya
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      windowTop: window.top.scrollY
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },
  methods: {
    onScroll() {
      this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
    }
  }
}
</script>

<style scoped>
  #footer {
    background-color: theme('colors.primary');
  }

  #button {
    display: inline-block;
    width: 50px;
    height: 50px;
    text-align: center;
    position: fixed;
    bottom: 30px;
    right: 30px;
    transition: background-color .3s, 
      opacity .5s, visibility .5s;
    opacity: 0;
    visibility: hidden;
    z-index: 1000;
  }
  #button::after {
    content: "\f077";
    font-family: FontAwesome;
    font-weight: normal;
    font-style: normal;
    font-size: 2em;
    line-height: 50px;
    color: #fff;
  }
  #button:hover {
    cursor: pointer;
    background-color: #333;
  }
  #button:active {
    background-color: #555;
  }
  #button.show {
    opacity: 1;
    visibility: visible;
  }
</style>